import React, { useEffect, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './LayoutAdmin.scss';
import Turns from '../pages/Turns';
import Error404 from '../pages/Error404';
import Spin from '../components/Spin';

export default function LayoutAdmin({ routes }) {
  const {
    organization,
    onlineTurns,
    tenantId,
    versionPortal,
    portalTheme,
    loading,
  } = useSelector((store) => store.tenantData);

  // Configurar colores del tema dinámicamente
  useEffect(() => {
    if (portalTheme) {
      document.documentElement.style.setProperty(
        '--primaryColor',
        portalTheme.primaryColor
      );
      document.documentElement.style.setProperty(
        '--secondColor',
        portalTheme.secondColor
      );
    }
  }, [portalTheme]);

  // Título de la página
  useEffect(() => {
    document.title = `Turnos | ${organization || 'AmpinaSoft'}`;
  }, [organization]);

  // 🔄 Si está cargando la info de la organización, mostrar un spinner
  if (loading) return <Spin />;

  // 🚫 Si no hay turnos en línea, mostrar 404
  if (!onlineTurns) return <Error404 />;

  // 🌟 Si es un portal premium, cargar las rutas definidas
  if (onlineTurns && versionPortal === 'premium')
    return <LoadRoutes routes={routes} />;

  // 🏥 Si no es premium, redirigir a la ruta del tenant
  return tenantId ? (
    <Switch>
      <Route path={`/`} component={Turns} />
      <Redirect from="/" to={'/'} />
    </Switch>
  ) : (
    <Redirect to="/" />
  );
}

function LoadRoutes({ routes }) {
  return (
    <Switch>
      {routes.map((route, index) => (
        <Route
          key={index}
          path={route.path}
          exact={route.exact}
          component={route.component}
        />
      ))}
    </Switch>
  );
}
